import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { getConsent, setConsent, trackPageview } from "../../lib/analytics";

const ConsentBanner = () => {
  const [visible, setVisible] = useState(() => !getConsent());

  const decide = (value) => {
    setConsent(value);
    setVisible(false);
    if (value === "granted") trackPageview();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-0 inset-x-0 z-[70] p-4"
          data-testid="consent-banner"
        >
          <div className="max-w-3xl mx-auto rounded-2xl bg-white dark:bg-[#0D1434] border border-slate-200 dark:border-white/10 shadow-[0_30px_70px_-30px_rgba(42,49,146,0.5)] p-5 md:p-6 md:flex items-center gap-6">
            <div className="flex items-start gap-3 flex-1">
              <div className="w-9 h-9 rounded-xl bg-brand-sky/10 border border-brand-sky/25 flex items-center justify-center shrink-0">
                <ShieldCheck size={16} className="text-brand-navy dark:text-brand-sky" />
              </div>
              <p className="text-[13px] leading-relaxed text-slate-600 dark:text-slate-300">
                We use privacy-friendly, first-party analytics to understand which services visitors are interested in.
                No third-party ad trackers, ever. See our{" "}
                <Link to="/privacy" className="font-semibold text-brand-navy dark:text-brand-sky underline underline-offset-2">Privacy Policy</Link>.
              </p>
            </div>
            <div className="flex gap-2.5 mt-4 md:mt-0 shrink-0">
              <button
                data-testid="consent-decline-button"
                onClick={() => decide("denied")}
                className="rounded-full border border-slate-200 dark:border-white/15 px-5 py-2.5 text-xs font-bold text-slate-500 dark:text-slate-300 hover:border-brand-sky transition-colors duration-300"
              >
                Decline
              </button>
              <button
                data-testid="consent-accept-button"
                onClick={() => decide("granted")}
                className="rounded-full bg-brand-navy dark:bg-brand-sky text-white dark:text-brand-ink px-6 py-2.5 text-xs font-bold hover:shadow-[0_12px_30px_-10px_rgba(42,49,146,0.6)] transition-shadow duration-300"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
export default ConsentBanner;
